import React, { useMemo } from 'react';
import Markdown, { MarkdownOptions } from 'markdown-to-jsx';

import { createSafeElement } from './create-safe-element';

export type SafeMarkdownProps = {
    /** markdown with simple HTML (links, underline, bold...); a text written by people or a model, not trusted */
    children: string;
    /** a block (paragraphs) even for one line of text */
    block?: boolean;
    /** the links open in a new tab (rel noopener noreferrer is added by createSafeElement) */
    linksInNewTab?: boolean;
};

const NEW_TAB_LINKS = { a: { props: { target: '_blank' } } };

/** Markdown without scripts: only the allowed tags and attributes reach the page (create-safe-element) */
const SafeMarkdown = ({ children, block = false, linksInNewTab = false }: SafeMarkdownProps) => {
    const options = useMemo<MarkdownOptions>(
        () => ({
            createElement: createSafeElement,
            forceBlock: block,
            overrides: linksInNewTab ? NEW_TAB_LINKS : undefined
        }),
        [block, linksInNewTab]
    );

    return <Markdown options={options}>{children}</Markdown>;
};

export default SafeMarkdown;
